import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'wager',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: '',
    loadChildren: () => import('./menus/menus.routes').then((m) => m.routes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@amwager/authentication/feature-ion').then((m) => m.AuthenticationFeatureIonModule),
  },
  { path: '**', redirectTo: '/wager', pathMatch: 'full' }, // should be always in the last order
];
